import styled, { css, keyframes } from "styled-components";
import { lighten } from "polished";
import { borderRadius, color as colorHelper, units } from "@m/alchemy-theme";
const indeterminateAnimation = keyframes `
  0% {
    left: -35%;
    right: 100%; }
  60% {
    left: 100%;
    right: -90%; }
  100% {
    left: 100%;
    right: -90%; }
`;
const indeterminateShortAnimation = keyframes `
 0% {
    left: -200%;
    right: 100%; }
  60% {
    left: 107%;
    right: -8%; }
  100% {
    left: 107%;
    right: -8%; }
`;
export const LinearProgress = styled.div `
  position: relative;
  height: ${({ height }) => (height ? `${height}px` : units(1))};
  display: block;
  width: 100%;
  border-radius: ${({ height }) => (height ? `${height / 2}px` : borderRadius())};
  background-color: ${colorHelper("canvas")};
  background-clip: padding-box;
  overflow: hidden;
`;
export const Line = styled.div `
  ${(props) => props.variant === "determinate" &&
    css `
      position: absolute;
      top: 0;
      bottom: 0;
      background-image: linear-gradient(
        ${props.hasValidColor && props.color ? lighten(0.06, props.color) : colorHelper("base", { lighten: 0.06 })},
        ${props.hasValidColor && props.color ? props.color : colorHelper("base")}
      );
      transition: width 0.3s linear;
    `}

  ${(props) => props.variant === "indeterminate" &&
    css `
      background-image: linear-gradient(
        ${props.hasValidColor && props.color ? lighten(0.06, props.color) : colorHelper("base", { lighten: 0.06 })},
        ${props.hasValidColor && props.color ? props.color : colorHelper("base")}
      );

      :before {
        content: "";
        position: absolute;
        background-image: inherit;
        top: 0;
        left: 0;
        bottom: 0;
        will-change: left, right;
        animation: ${indeterminateAnimation} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      }

      :after {
        content: "";
        position: absolute;
        background-image: inherit;
        top: 0;
        left: 0;
        bottom: 0;
        will-change: left, right;
        animation: ${indeterminateShortAnimation} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
        animation-delay: 1.15s;
      }
    `}
`;
